module.exports = __webpack_public_path__ + "static/media/21.1ab08937.jpg";